import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import i18n from 'i18next';

import { Button, ButtonGroup } from 'uikit/buttons';
import { Loading } from 'uikit/loaders';

import styles from '../styles/newItemFormButtons.module.scss';

const NewItemFormButtons = ({
  cancelText = '',
  hasError = false,
  isFullScreen = true,
  isSubmitDisabled = false,
  isSubmitting = false,
  onCancel = () => {},
  onSubmit = () => {},
  submitColor = 'brand',
  hasCancelButton = true,
  submitText = '',
}) => (
  <ButtonGroup
    className={classnames(styles.element, isFullScreen && styles.isFullScreen)}
    data-no-focus-lock
  >
    <Button
      color={submitColor}
      isDisabled={isSubmitting || hasError || isSubmitDisabled}
      onClick={onSubmit}
      text={submitText || i18n.t('save', 'Save')}
    />
    {hasCancelButton && (
      <Button onClick={onCancel} text={cancelText || i18n.t('cancel', 'Cancel')} variant="ghost" />
    )}
    {isSubmitting && <Loading />}
  </ButtonGroup>
);

NewItemFormButtons.propTypes = {
  cancelText: PropTypes.string,
  hasError: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  isSubmitDisabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  hasCancelButton: PropTypes.bool,
  submitColor: PropTypes.oneOf(['primary', 'secondary', 'brand', 'negative']),
  submitText: PropTypes.string,
};

export default React.memo(NewItemFormButtons);
